export default {
  state: {
    isCollapse: false, // 左侧菜单是否展开
    button_icon: 'el-icon-s-fold', // 控制菜单图标
    tabsListCrumbs: [
      {
        path: '/',
        name: 'home',
        label: '首页',
        icon: 's-home',
        url: 'Home/Home'
      }
    ],
  },
  mutations: {
    collapseMenu(state) {
      if (state.isCollapse) {
        state.button_icon = 'el-icon-s-fold'
        state.isCollapse = false
      } else {
        state.button_icon = 'el-icon-s-unfold'
        state.isCollapse = true
      }
    },
    setCollapse(state, collapsed) {
      state.isCollapse = collapsed
      state.button_icon = collapsed ? 'el-icon-s-unfold' : 'el-icon-s-fold'
    },
    updateMenu(state, [val]) {
      state.tabsListCrumbs = val
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/tab.js